import * as Sentry from '@sentry/react';
import { Observer } from 'mobx-react';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import ConfirmationProvider from 'components/Confirmation/ConfirmationProvider';
import PwaInstallBanner from 'components/PwaInstallBanner';
import { AuthPageWrapper, BottomElipse, PageContainer, TopElipse } from 'modules/Auth/styled';
import Providers from 'providers';
import store from 'store';

import StoreProvider from '@common/components/StoreProvider';

const InstallPwaBrowserView = (
	<Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
		<StoreProvider store={store}>
			<Providers>
				<Observer>
					{() => (
						<BrowserRouter>
							<ThemeProvider theme={store.theme.theme}>
								<ConfirmationProvider>
									<CssBaseline enableColorScheme />
									<AuthPageWrapper>
										<PageContainer sx={{ justifyContent: 'center' }}>
											<PwaInstallBanner />
										</PageContainer>
										<TopElipse />
										<BottomElipse />
									</AuthPageWrapper>
								</ConfirmationProvider>
							</ThemeProvider>
						</BrowserRouter>
					)}
				</Observer>
			</Providers>
		</StoreProvider>
	</Sentry.ErrorBoundary>
);

export default InstallPwaBrowserView;
